import React, { useEffect, useState } from 'react'
import { File } from 'react-bootstrap-icons';
import { useParams } from 'react-router'
import { apiAxios } from '../services/Api';
import Zambie from './_details/Zambie';
import Tanzanie from './_details/Tanzanie';

function Details() {
    const params = useParams();
    const [data, setData] = useState();

    const afficher = () => {
        switch (params.type) {
            case 'tra':
                return <Tanzanie data={data} declaration={params.declaration} />
            case 'zra':
                return <Zambie data={data} />
        }
    }

    useEffect(() => {
        apiAxios("api/details/" + params.type + "?declaration=" + params.declaration).then(setData)
    }, [])
    return (
        <div>
            <h3 className='text-center'>
                <File />&nbsp;
                <span className='text-muted'>{params.declaration}</span>
            </h3>
            {data && afficher()}
        </div>
    )
}

export default Details
